export const Types = {
  GET_SOURCE_LIST_REQUEST: 'GET_SOURCE_LIST_REQUEST',
  GET_SOURCE_LIST_SUCCESS: 'GET_SOURCE_LIST_SUCCESS',
  GET_SOURCE_LIST_FAIL: 'GET_SOURCE_LIST_FAIL',

  DELETE_SOURCE_REQUEST: 'DELETE_SOURCE_REQUEST',
  DELETE_SOURCE_SUCCESS: 'DELETE_SOURCE_SUCCESS',
  DELETE_SOURCE_FAIL: 'DELETE_SOURCE_FAIL',
  DELETE_SOURCE_CLEAN: 'DELETE_SOURCE_CLEAN',

  CREATE_SOURCE_REQUEST: 'CREATE_SOURCE_REQUEST',
  CREATE_SOURCE_SUCCESS: 'CREATE_SOURCE_SUCCESS',
  CREATE_SOURCE_FAIL: 'CREATE_SOURCE_FAIL',
  CREATE_SOURCE_CLEAN: 'CREATE_SOURCE_CLEAN',

  GET_ID_SOURCE_REQUEST: 'GET_ID_SOURCE_REQUEST',
  GET_ID_SOURCE_SUCCESS: 'GET_ID_SOURCE_SUCCESS',
  GET_ID_SOURCE_FAIL: 'GET_ID_SOURCE_FAIL',
  GET_ID_SOURCE_CLEAN: 'GET_ID_SOURCE_CLEAN',

  UPDATE_SOURCE_REQUEST: 'UPDATE_SOURCE_REQUEST',
  UPDATE_SOURCE_SUCCESS: 'UPDATE_SOURCE_SUCCESS',
  UPDATE_SOURCE_FAIL: 'UPDATE_SOURCE_FAIL',
  UPDATE_SOURCE_CLEAN: 'UPDATE_SOURCE_CLEAN',
};

const INIT_STATE = {
  loading: false,
  error: false,
  data: [],
  amount: 10,

  deleteLoading: false,
  deleteError: false,
  deleteSuccess: false,

  createLoading: false,
  createError: false,
  createSuccess: false,

  idLoading: false,
  idError: false,
  idData: null,

  updateLoading: false,
  updateError: false,
  updateSuccess: false,
};

export default function Source(state = INIT_STATE, action) {
  switch (action.type) {
    case Types.GET_SOURCE_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case Types.GET_SOURCE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload.data || action.payload,
        amount: action.payload.total,
      };
    case Types.GET_SOURCE_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
      };

    case Types.DELETE_SOURCE_REQUEST:
      return {
        ...state,
        deleteLoading: true,
        deleteError: false,
        deleteSuccess: false,
      };
    case Types.DELETE_SOURCE_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
        deleteError: false,
        deleteSuccess: true,
      };
    case Types.DELETE_SOURCE_FAIL:
      return {
        ...state,
        deleteLoading: false,
        deleteError: true,
        deleteSuccess: false,
      };
    case Types.DELETE_SOURCE_CLEAN:
      return {
        ...state,
        deleteLoading: false,
        deleteError: false,
        deleteSuccess: false,
      };

    case Types.CREATE_SOURCE_REQUEST:
      return {
        ...state,
        createLoading: true,
        createError: false,
        createSuccess: false,
      };
    case Types.CREATE_SOURCE_SUCCESS:
      return {
        ...state,
        createLoading: false,
        createError: false,
        createSuccess: true,
      };
    case Types.CREATE_SOURCE_FAIL:
      return {
        ...state,
        createLoading: false,
        createError: true,
        createSuccess: false,
      };
    case Types.CREATE_SOURCE_CLEAN:
      return {
        ...state,
        createLoading: false,
        createError: false,
        createSuccess: false,
      };

    case Types.GET_ID_SOURCE_REQUEST:
      return {
        ...state,
        idLoading: true,
        idError: false,
      };
    case Types.GET_ID_SOURCE_SUCCESS:
      return {
        ...state,
        idLoading: false,
        idError: false,
        idData: action.payload,
      };
    case Types.GET_ID_SOURCE_FAIL:
      return {
        ...state,
        idLoading: false,
        idError: true,
      };
    case Types.GET_ID_SOURCE_CLEAN:
      return {
        ...state,
        idLoading: false,
        idError: false,
        idData: null,
      };

    case Types.UPDATE_SOURCE_REQUEST:
      return {
        ...state,
        updateLoading: true,
        updateError: false,
        updateSuccess: false,
      };
    case Types.UPDATE_SOURCE_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        updateError: false,
        updateSuccess: true,
      };
    case Types.UPDATE_SOURCE_FAIL:
      return {
        ...state,
        updateLoading: false,
        updateError: true,
        updateSuccess: false,
      };
    case Types.UPDATE_SOURCE_CLEAN:
      return {
        ...state,
        updateLoading: false,
        updateError: false,
        updateSuccess: false,
      };

    default:
      return state;
  }
}

export const Creators = {
  // GET
  getSourceListRequest: payload => ({
    type: Types.GET_SOURCE_LIST_REQUEST,
    payload,
  }),
  getSourceListSuccess: payload => ({
    type: Types.GET_SOURCE_LIST_SUCCESS,
    payload,
  }),
  getSourceListFail: () => ({
    type: Types.GET_SOURCE_LIST_FAIL,
  }),

  // DELETE
  deleteSourceRequest: payload => ({
    type: Types.DELETE_SOURCE_REQUEST,
    payload,
  }),
  deleteSourceSuccess: () => ({
    type: Types.DELETE_SOURCE_SUCCESS,
  }),
  deleteSourceFail: () => ({
    type: Types.DELETE_SOURCE_FAIL,
  }),
  deleteSourceClean: () => ({
    type: Types.DELETE_SOURCE_CLEAN,
  }),

  // CREATE
  createSourceRequest: payload => ({
    type: Types.CREATE_SOURCE_REQUEST,
    payload,
  }),
  createSourceSuccess: payload => ({
    type: Types.CREATE_SOURCE_SUCCESS,
    payload,
  }),
  createSourceFail: () => ({
    type: Types.CREATE_SOURCE_FAIL,
  }),
  createSourceClean: () => ({
    type: Types.CREATE_SOURCE_CLEAN,
  }),

  // GET ID
  getIdSourceRequest: payload => ({
    type: Types.GET_ID_SOURCE_REQUEST,
    payload,
  }),
  getIdSourceSuccess: payload => ({
    type: Types.GET_ID_SOURCE_SUCCESS,
    payload,
  }),
  getIdSourceFail: () => ({
    type: Types.GET_ID_SOURCE_FAIL,
  }),
  getIdSourceClean: () => ({
    type: Types.GET_ID_SOURCE_CLEAN,
  }),

  // UPDATE
  updateSourceRequest: payload => ({
    type: Types.UPDATE_SOURCE_REQUEST,
    payload,
  }),
  updateSourceSuccess: payload => ({
    type: Types.UPDATE_SOURCE_SUCCESS,
    payload,
  }),
  updateSourceFail: () => ({
    type: Types.UPDATE_SOURCE_FAIL,
  }),
  updateSourceClean: () => ({
    type: Types.UPDATE_SOURCE_CLEAN,
  }),
};
